import * as svg4everybody from 'svg4everybody';

export default {
  data: '',
  svgFilePath: '/Assets/Icons/map.svg',
  svgFileRevision: '{{TIMESTAMP_HERE_FROM_BUILD_STEP}}',
  hasSupport(): boolean {
    const svgSupported: any = document.createElementNS &&
                         document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
    const localStorageSupported: boolean = 'localStorage' in window && window.localStorage !== null;

    return svgSupported && localStorageSupported;
  },
  loadSvg(): any {
    if (localStorage.getItem('inlineSVGrev') === this.svgFileRevision) {
      this.data = localStorage.getItem('inlineSVGdata');

      if (this.data) {
        this.insertSvg();
        return true;
      }
    }

    try {
      const request: XMLHttpRequest = new XMLHttpRequest();
      request.open('GET', `${this.svgFilePath}`, true);
      request.onload = () => {
        if (request.status >= 200 && request.status < 400) {
          this.data = request.responseText;
          this.afterAjax();
        }
      };
      request.send();
    } catch (e) { /* */ }
  },
  afterAjax(): void {
    if (this.svgFileRevision.indexOf('{{') === -1) {
      localStorage.setItem('inlineSVGdata', this.data);
      localStorage.setItem('inlineSVGrev', this.svgFileRevision);
    }
    this.insertSvg();
  },
  insertSvg(): void {
    document.body.insertAdjacentHTML('afterbegin', this.data);
    svg4everybody();
  },
  init(): any {
    if (!this.hasSupport()) {
      return false;
    }
    this.loadSvg();
  }
};
